import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { TextInput, Image } from "hesus-ui-kit";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import editIcon from "@icons/ic-edit-blue.svg";
import cancelIcon from "@icons/ic-edit-cancel.svg";
import yesIcon from "@icons/ic-green-edit.svg";
import errorIcon from "@icons/ic-error.svg";
import { quoteKOColors, quoteKOStatuses } from "@utils/constants";
import QuoteService from "./QuoteService";
import QuoteValidatePoConsistency from "../QuoteValidatePoConsistency";
import "./QuoteView.scss";
import { renderPriceWithCurrencyWithoutUnit, addSpace } from "@utils/utils";
import {
  QuoteViewContainer,
  SectionContainer,
  QuoteRightInfo,
  QuoteTitle,
  QuoteLeftDiv,
  QuoteStatusBtn,
  QuoteMargin,
  MarginDiv,
  GridRow,
  CommentContainer,
  CommentWraper,
  CommentPara,
  ErrorDiv,
  RequiredMessage,
} from "./QuoteView.styled";

const QuoteView = (props) => {
  const { t, quoteId, setIsRefeshSiteData } = props;
  const params = useParams();
  const siteId = parseInt(params.id, 10);
  const [isLoading, setIsLoading] = useState(false);
  const [quoteData, setQuoteData] = useState([]);

  const [oldSiteKoComment, setOldSiteKoComment] = useState("");
  const [siteKoComment, setSiteKoComment] = useState("");
  const [onSiteCommentEdit, setOnSiteCommentEdit] = useState(false);
  const [koCommentLoading, setKoCommentLoading] = useState(false);

  const [oldFollowUpComment, setOldFollowUpComment] = useState("");
  const [followUpComment, setFollowUpComment] = useState("");
  const [quoteItemDateError, setQuoteItemDateError] = useState("");
  const [onFollowUpCommentEdit, setOnFollowUpCommentEdit] = useState(false);
  const [followUpCommentLoading, setFollowUpCommentLoading] = useState(false);
  const [isRefreshQuoteData, setIsRefreshQuoteData] = useState(false);

  const fetchQuoteInfo = () => {
    setIsLoading(true);
    axios
      .get(`/sites/${siteId}/kickoff/${quoteId}`)
      .then((response) => {
        setQuoteData(response.data[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching places",
            error
          );
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchQuoteInfo();
  }, [quoteId]);

  useEffect(() => {
    if (isRefreshQuoteData) {
      fetchQuoteInfo();
      setIsRefreshQuoteData(false);
    }
  }, [isRefreshQuoteData]);

  useEffect(() => {
    if (quoteData?.site?.koComment) {
      setSiteKoComment(quoteData?.site?.koComment);
      setOldSiteKoComment(quoteData?.site?.koComment);
    }
    if (quoteData?.followupComment) {
      setFollowUpComment(quoteData?.followupComment);
      setOldFollowUpComment(quoteData?.followupComment);
    }
  }, [quoteData]);

  const onSiteKoCommentChange = (e) => {
    setSiteKoComment(e.target.value);
  };

  const onSiteKoCommentEdit = (type) => {
    setOnSiteCommentEdit(!onSiteCommentEdit);
    if (type === "close") {
      setSiteKoComment(oldSiteKoComment);
    }
  };

  const saveSiteKoCommentEdit = () => {
    setKoCommentLoading(true);
    const dataModified = new FormData();
    dataModified.append("id", siteId ?? null);
    dataModified.append("koComment", siteKoComment);
    axios
      .post(`/sites/${siteId}`, dataModified)
      .then((response) => {
        setSiteKoComment(siteKoComment);
        setOldSiteKoComment(siteKoComment);
        setOnSiteCommentEdit(!onSiteCommentEdit);
        setKoCommentLoading(false);
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching places",
            error
          );
        }
        setKoCommentLoading(false);
      });
  };

  const onFollowUpCommentChange = (e) => {
    setFollowUpComment(e.target.value);
  };

  const saveQuoteFollowUpCommentEdit = () => {
    setFollowUpCommentLoading(true);
    axios
      .put(`/quotes/${quoteId}`, { followUpComment, siteId })
      .then((response) => {
        setFollowUpComment(followUpComment);
        setOldFollowUpComment(followUpComment);
        setOnFollowUpCommentEdit(!onFollowUpCommentEdit);
        setQuoteData(response.data[0]);
        setFollowUpCommentLoading(false);
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching places",
            error
          );
        }
        setFollowUpCommentLoading(false);
      });
  };

  const onQuoteFollowUpCommentEdit = (type) => {
    setOnFollowUpCommentEdit(!onFollowUpCommentEdit);
    if (type === "close") {
      setFollowUpComment(oldFollowUpComment);
    }
  };

  return (
    <>
      {isLoading && (
        <QuoteViewContainer>
          <ClipLoader size={20} color="#1bace4" />
        </QuoteViewContainer>
      )}
      {!isLoading && quoteData?.id && (
        <QuoteViewContainer>
          <SectionContainer>
            <QuoteRightInfo>
              <div>
                <QuoteTitle marginTop="10px">
                  {t("QUOTE") + " # " + quoteData?.id + " " + quoteData?.name}
                </QuoteTitle>
                {quoteData?.purchaseOrder && (
                  <QuoteTitle fontWeight="400" fontSize="16px" marginTop="30px">
                    {t("KICK_OFF_PAGE_QUOTE_SUMMARY_PURCHASE_ORDER") +
                      " # " +
                      quoteData?.purchaseOrder}
                  </QuoteTitle>
                )}
              </div>
            </QuoteRightInfo>
            <QuoteLeftDiv>
              <QuoteStatusBtn
                backgroundColor={quoteKOColors[quoteData?.koStatus]}
              >
                <span id="title-banner-status-info-text">
                  {t(quoteKOStatuses[quoteData?.koStatus])}
                </span>
              </QuoteStatusBtn>
              <MarginDiv>
                <QuoteMargin>
                  {t("TOTAL")}{" "}
                  {renderPriceWithCurrencyWithoutUnit(
                    addSpace(quoteData?.totalExcludingTax),
                    quoteData?.currency?.symbol,
                    quoteData?.currency?.position
                  )}
                </QuoteMargin>
                <QuoteMargin fontWeight="400">
                  ({quoteData?.totalMarginRate + "%"} )
                </QuoteMargin>
              </MarginDiv>
            </QuoteLeftDiv>
          </SectionContainer>

          <GridRow column="49% 49%" marginTop="20px;">
            <CommentContainer>
              <CommentWraper>
                {!onSiteCommentEdit && (
                  <CommentPara>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: siteKoComment,
                      }}
                    ></div>
                  </CommentPara>
                )}
                {onSiteCommentEdit && (
                  <TextInput
                    type="textarea"
                    className="quote_comment"
                    label=""
                    name="quote_contextual_comment"
                    id="quote_contextual_comment"
                    isFloat
                    onChange={onSiteKoCommentChange}
                    placeholder={t(
                      "KICK_OFF_PAGE_SITE_INFO_HELPTEXT_CONTEXTUAL_COMMENT"
                    )}
                    value={String(siteKoComment)}
                    errorStyles={{ "font-style": "italic" }}
                    containerStyles={{ marginTop: "1px" }}
                    inputStyles={{
                      border: "1px solid #fff !important;",
                    }}
                    error=""
                  />
                )}
                <div>
                  {!onSiteCommentEdit &&
                    quoteData.isSiteCommentEdit > 0 &&
                    quoteData.site.koStatus !== 3 && (
                      <Image
                        src={editIcon}
                        onClick={() => onSiteKoCommentEdit("edit")}
                        styles={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  {onSiteCommentEdit && !koCommentLoading && (
                    <>
                      <Image
                        src={yesIcon}
                        styles={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                          marginRight: "5px",
                        }}
                        alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                        title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                        onClick={saveSiteKoCommentEdit}
                      />
                      <Image
                        src={cancelIcon}
                        alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL")}
                        title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL")}
                        onClick={() => onSiteKoCommentEdit("close")}
                        styles={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </>
                  )}
                  {koCommentLoading && <ClipLoader size={20} color="#1bace4" />}
                </div>
              </CommentWraper>
            </CommentContainer>

            <CommentContainer>
              <CommentWraper>
                {!onFollowUpCommentEdit && (
                  <CommentPara>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: followUpComment,
                      }}
                    ></div>
                  </CommentPara>
                )}
                {onFollowUpCommentEdit && (
                  <TextInput
                    type="textarea"
                    label=""
                    name="quote_followup_comment"
                    id="quote_followup_comment"
                    isFloat
                    onChange={onFollowUpCommentChange}
                    placeholder={t(
                      "KICK_OFF_PAGE_QUOTE_HELPTEXT_FOLLOWUP_COMMENT"
                    )}
                    value={String(followUpComment)}
                    errorStyles={{ "font-style": "italic" }}
                    containerStyles={{ marginTop: "1px" }}
                    inputStyles={{ border: "1px solid #fff !important" }}
                    error=""
                  />
                )}
                <div>
                  {!onFollowUpCommentEdit &&
                    quoteData.isFollowUpCommentEdit > 0 && (
                      <Image
                        src={editIcon}
                        onClick={() => onQuoteFollowUpCommentEdit("edit")}
                        styles={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  {onFollowUpCommentEdit && !followUpCommentLoading && (
                    <>
                      <Image
                        src={yesIcon}
                        styles={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                          marginRight: "5px",
                        }}
                        alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                        title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                        onClick={saveQuoteFollowUpCommentEdit}
                      />
                      <Image
                        src={cancelIcon}
                        alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL")}
                        title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL")}
                        onClick={() => onQuoteFollowUpCommentEdit("close")}
                        styles={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                        }}
                      />
                      {followUpCommentLoading && (
                        <ClipLoader size={20} color="#1bace4" />
                      )}
                    </>
                  )}
                </div>
              </CommentWraper>
            </CommentContainer>
          </GridRow>
          {quoteItemDateError !== "" && (
            <GridRow column="1fr">
              <ErrorDiv>
                <RequiredMessage>
                  <Image
                    src={errorIcon}
                    alt="warning"
                    styles={{
                      height: "18px",
                      width: "18px",
                      cursor: "pointer",
                    }}
                  />{" "}
                  {t("KICK_OFF_PAGE_QUOTE_ITEM_MISSING_DATES_ERROR")}
                </RequiredMessage>
              </ErrorDiv>
            </GridRow>
          )}
          <QuoteService
            quoteData={quoteData}
            siteId={siteId}
            setQuoteData={setQuoteData}
            isOperationType={quoteData?.isOperationType}
            isStudyTeamType={quoteData?.isStudyTeamType}
            setIsRefreshQuoteData={setIsRefreshQuoteData}
            setIsRefeshSiteData={setIsRefeshSiteData}
          />
          {parseInt(quoteData.site.koStatus, 10) === 2 &&
            parseInt(quoteData.koStatus, 10) === 0 && (
              <QuoteValidatePoConsistency
                setQuoteData={setQuoteData}
                quoteId={quoteData?.id}
                siteId={siteId}
                setQuoteItemDateError={setQuoteItemDateError}
                quoteData={quoteData}
              />
            )}
        </QuoteViewContainer>
      )}
    </>
  );
};
QuoteView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(QuoteView);
